import { Component, OnChanges, Input, Output, EventEmitter, AfterViewInit} from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnChanges {

  @Input() labelKey;
  @Input() idKey;
  @Input() options: any;
  @Input() model;
  @Input() keepOrder : boolean = false;
  @Output() selectChange : EventEmitter<string> = new EventEmitter<string>();
  @Input() checkError : boolean = false;
  @Input() placeHolder : string = "Select"
  @Input() sortRequired : boolean = false;

  bindActiveEnter(obj) {
    $(obj.target).parent().parent().find('div.dropdown-item.active').removeClass("active").addClass('inactive');
  }

  bindActiveLeave(obj) {
    $(obj.target).parent().parent().find('div.dropdown-item.inactive').removeClass("inactive").addClass('active');
  }
   
  get label() {
    if (typeof this.model === 'object') {
      // console.log(this.model !=-1 ,this.model[this.labelKey] )
      return this.model && this.model !=-1 ? this.model[this.labelKey] : this.placeHolder;
    } else {
       return this.model && this.model !=-1 ? this.options[this.model] : this.placeHolder;
    }
  }

  get hasError() {
    if (!this.checkError) {
      return false;
    }
    if (typeof this.model === 'object') {
      return this.model && this.model[this.labelKey].length  > 0 ? false : true;
    } else {
       return this.model && this.model != '-1' && this.options[this.model].length  > 0 ? false : true;
    }
  }

  isActive(option) {
    //if (this.model === undefined) {this.getModelView();}


    if (!this.model) {
      return false;
    }
    if (typeof this.model === 'object') {
      return option[this.idKey] === this.model[this.idKey];
    } else {
      return option[this.idKey] === this.model;
    }
  }

  ngOnChanges() {
    this.getModelView();
  }

  getModelView() {
    if (this.options !== undefined && Array.isArray(this.options)) {
      let originalOptions = [...this.options];
      if (this.model !== undefined && typeof this.model !== 'object'
      && originalOptions.length > 0) {
        this.model = originalOptions.find(
          currentOption => currentOption[this.idKey] === this.model
        );
      }
    }
  }

  select(option, obj) {
    $(obj.target).parent().parent().find('div.dropdown-item.inactive').removeClass("inactive");
    this.model = option;
    this.selectChange.emit(option[this.idKey]);
  }

  keepItemOrder(a, b) {
    return a;
     //return 0;
    // if (typeof a === 'object') {
    //   return a;
    // } else {
    //   if (a < b) return -1;
    //   if (a > b) return 1;
    //   return 0;
    // }
  }



  sortorder(a, b){
    const bandA = a.value.key.toUpperCase();
	  const bandB = b.value.key.toUpperCase();
    let comparison = 0;
	  if (bandA > bandB) {
	    comparison = 1;
	  } else if (bandA < bandB) {
	    comparison = -1;
	  }
	  return comparison;
  }
}
